import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { InputField } from '../layout/form-fields/inputs/InputField';

export default function SettingsSearchField({
	value,
	onChange,
	field = 'title',
	placeholder = 'Search',
	debounce = true,
	debounceTime = 400,
	autoFocus
}) {
	const [inputValue, setInputValue] = useState(value ?? '');

	useEffect(() => {
		setInputValue(value ?? '');
	}, [value]);

	const debouncedOnChange = useMemo(() => {
		if (!debounce || !onChange) {
			return null;
		}

		return _.debounce(onChange, debounceTime);
	}, [debounce, debounceTime, onChange]);

	useEffect(() => {
		return () => {
			debouncedOnChange?.cancel();
		};
	}, [debouncedOnChange]);

	const handleValueChange = useCallback(
		newValue => {
			setInputValue(newValue);

			if (debouncedOnChange) {
				debouncedOnChange(newValue);
			} else if (onChange) {
				onChange(newValue);
			}
		},
		[debouncedOnChange, onChange]
	);

	return (
		<div className="settings-search-field">
			<InputField
				autoFocus={autoFocus}
				className="has-text-left no-margin-bottom"
				field={field}
				type="search"
				icon="fa-search"
				placeholder={placeholder}
				value={inputValue}
				onValueChange={handleValueChange}
				debounce={false}
			/>
		</div>
	);
}
